// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate
// } from "react-router-dom";

// import Login from "./components/Login";
// import Home from "./components/Home";
// import Agent from "./components/Agent";
// import ChatAgent from "./components/ChatAgent";
// import Report from "./components/Report";
// import Dashboard from "./components/Dashboard";

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = React.useState(
//     localStorage.getItem("isAuthenticated") === "true"
//   );

//   const handleLogin = () => {
//     setIsAuthenticated(true);
//     localStorage.setItem("isAuthenticated", "true");
//   };

//   const handleLogout = () => {
//     setIsAuthenticated(false);
//     localStorage.clear();
//   };

//   return (
//     <Router>
//       <Routes>
//         {!isAuthenticated && (
//           <>
//             <Route
//               path="/login"
//               element={<Login onLogin={handleLogin} />}
//             />
//             <Route path="*" element={<Navigate to="/login" />} />
//           </>
//         )}

//         {isAuthenticated && (
//           <>
//             <Route
//               path="/home"
//               element={<Home onLogout={handleLogout} />}
//             />
//             <Route
//               path="/agent"
//               element={<Agent onLogout={handleLogout} />}
//             />
//             <Route
//               path="/agent/chat"
//               element={<ChatAgent onLogout={handleLogout} />}
//             />
//             <Route
//               path="/report"
//               element={<Report onLogout={handleLogout} />}
//             />
//             <Route
//               path="/dashboard"
//               element={<Dashboard onLogout={handleLogout} />}
//             />
//             <Route path="*" element={<Navigate to="/home" />} />
//           </>
//         )}
//       </Routes>
//     </Router>
//   );
// }

// export default App;






import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";

import Login from "./components/Login";
import Home from "./components/Home";
import MyWork from "./components/MyWork";
import Agent from "./components/Agent";
import Analytics from "./components/Report";
import Dashboard from "./components/Dashboard";
import CRM from "./components/CRM";
import Insights from "./components/Insights";
import Claims from "./components/Claims";
import DocumentUpload from "./components/DocumentUpload";
import FnolReviewWindow from "./components/FnolReviewWindow";
import "./components/DarkDashboardTheme.css";

const AuthenticatedRoot = ({ onLogout }) => {
  const location = useLocation();
  const fnolReviewId = new URLSearchParams(location.search).get("fnolReview");

  return fnolReviewId ? <FnolReviewWindow onLogout={onLogout} /> : <Navigate to="/home" replace />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(
    localStorage.getItem("isAuthenticated") === "true"
  );

  const handleLogin = (user) => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("currentUser", JSON.stringify(user));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.clear();
  };

  return (
    <Router>
      <Routes>
        {!isAuthenticated && (
          <>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}

        {isAuthenticated && (
          <>
            <Route path="/" element={<AuthenticatedRoot onLogout={handleLogout} />} />
            <Route path="/home" element={<Home onLogout={handleLogout} />} />
            <Route path="/my-work" element={<MyWork onLogout={handleLogout} />} />
            <Route path="/ai-agents" element={<Agent onLogout={handleLogout} />} />
            <Route path="/agent" element={<Navigate to="/ai-agents" />} />
            <Route path="/analytics" element={<Analytics onLogout={handleLogout} />} />
            <Route path="/report" element={<Navigate to="/analytics" />} />
            <Route path="/insights" element={<Insights onLogout={handleLogout} />} />
            <Route path="/dashboard" element={<Navigate to="/ops-dashboard" />} />
            <Route path="/ops-dashboard" element={<Dashboard onLogout={handleLogout} dashboardType="ops" />} />
            <Route path="/agent-dashboard" element={<Dashboard onLogout={handleLogout} dashboardType="agent" />} />
            <Route path="/document-upload" element={<DocumentUpload onLogout={handleLogout} />} />
            <Route path="/fnol-review/:recordId" element={<FnolReviewWindow onLogout={handleLogout} />} />
            <Route path="/crm" element={<CRM onLogout={handleLogout} />} />
            <Route path="/claims" element={<Claims onLogout={handleLogout} />} />
            <Route path="*" element={<Navigate to="/home" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;

